import { formatDateHuman, parseDateRaw } from "../date-utils";
export const traceabilityInfoDtoFields = [{
        name: "date",
        title: "Data",
        render: (record) => formatDateHuman(parseDateRaw(record.date))
    }, {
        name: "reference",
        title: "Riferimento",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.reference
    }, {
        name: "description",
        title: "Descrizione",
        render: (record) => record.description
    }, {
        name: "supplier",
        title: "Provenienza",
        render: (record) => record.supplier
    }, {
        name: "ingressDdt",
        title: "DDT Ingresso",
        render: (record) => record.ingressDdt
    }];
export const traceabilityInfoSlaughterDtoFields = [{
        name: "date",
        title: "Data",
        render: (record) => formatDateHuman(parseDateRaw(record.date))
    }, {
        name: "reference",
        title: "Riferimento",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.reference
    }, {
        name: "description",
        title: "Descrizione",
        render: (record) => record.description
    }, {
        name: "supplier",
        title: "Provenienza",
        render: (record) => record.supplier
    }, {
        name: "ingressDdt",
        title: "Mod. 4",
        render: (record) => record.ingressDdt
    }];
